import { render, staticRenderFns } from "./LProjectObjectInputTags.vue?vue&type=template&id=aa87c4dc&"
import script from "./LProjectObjectInputTags.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectInputTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports